
export interface IAmazingOffer extends ng.resource.IResource<IAmazingOffer> {
    Id: number;
    IsDeleted : boolean;
}
export interface IAmazingOfferResource extends ng.resource.IResourceClass<IAmazingOffer> {
    create: ng.resource.IResourceMethod<IAmazingOffer>;
    changeSort: ng.resource.IResourceMethod<IAmazingOffer>;
}
export function amazingOffer_factory($resource: ng.resource.IResourceService, MyConstant): IAmazingOfferResource {
    "ngInject";
    return <IAmazingOfferResource>$resource(MyConstant.ApiUrl + 'amazingOffer', {
    }, {
            query: {
                method: 'GET',
                url: MyConstant.ApiUrl + 'AmazingOffer/GetAll',
                isArray: true
            },
            get: {
                method: 'GET',
                url: MyConstant.ApiUrl + 'AmazingOffer/Get?id=:id'
            },
            create: {
                method: 'POST',
                url: MyConstant.ApiUrl + 'AmazingOffer/Save'
            },
            delete: {
                method: 'GET',
                url: MyConstant.ApiUrl + 'AmazingOffer/Remove?Id=:id'
            },
            changeSort: {
                method: 'POST',
                url: MyConstant.ApiUrl + 'AmazingOffer/SaveSortedItems'
            },
        });
}



// WEBPACK FOOTER //
// ./src/factories/amazingOffer/amazingOffer.ts